import React from 'react';
import * as S from './BottomSheetSelect.styles';
import { BottomSheetSelectOption } from './BottomSheetSelectOption';
import { BottomSheet } from '@/components/UI/BottomSheet/BottomSheet';

type Props = {
  dataTestId?: string;
  title: string;
  isOpen: boolean;
  close: () => void;
  hasHeadBorder?: boolean;
  options: {
    dataTestId?: string;
    id?: string;
    label: string;
    isSelected: boolean;
    onSelect: () => void;
  }[];
};

export const BottomSheetSelect = ({
  dataTestId,
  title,
  isOpen,
  close,
  hasHeadBorder = false,
  options,
}: Props) => (
  <BottomSheet
    dataTestId={dataTestId}
    isInPortal
    isPageLocked
    hasHeadBorder={hasHeadBorder}
    title={title}
    isOpen={isOpen}
    close={close}
  >
    <S.BottomSheetSelectContent>
      {options.map(
        ({ dataTestId: optionDataTestId, id, label, isSelected, onSelect }) => {
          return (
            <BottomSheetSelectOption
              key={label}
              dataTestId={optionDataTestId}
              id={id}
              label={label}
              isSelected={isSelected}
              onSelect={() => {
                onSelect();
                close();
              }}
            />
          );
        }
      )}
    </S.BottomSheetSelectContent>
  </BottomSheet>
);
